import Resource from "./resource.js";
import { Groups } from "./groups.js";
export class Organizations extends Resource {
    /**
     * Organizations
     */
    #client;
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/organizations",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
        this.#client = client;
    }
    find = this.makeRequest({
        method: "GET",
        path: "/",
    });
    findOne = this.makeRequest({
        method: "GET",
        path: "/{id}",
        urlParamKeys: ["id"],
    });
    create = this.makeRequest({
        method: "POST",
        returnResourceIdInLocationHeader: { field: "id" },
    });
    delById = this.makeRequest({
        method: "DELETE",
        path: "/{id}",
        urlParamKeys: ["id"],
    });
    updateById = this.makeUpdateRequest({
        method: "PUT",
        path: "/{id}",
        urlParamKeys: ["id"],
    });
    listMembers = this.makeRequest({
        method: "GET",
        path: "/{orgId}/members",
        urlParamKeys: ["orgId"],
    });
    addMember = this.makeRequest({
        method: "POST",
        path: "/{orgId}/members",
        urlParamKeys: ["orgId"],
        payloadKey: "userId",
    });
    delMember = this.makeRequest({
        method: "DELETE",
        path: "/{orgId}/members/{userId}",
        urlParamKeys: ["orgId", "userId"],
    });
    getMember = this.makeRequest({
        method: "GET",
        path: "/{orgId}/members/{userId}",
        urlParamKeys: ["orgId", "userId"],
    });
    memberOrganizations = this.makeRequest({
        method: "GET",
        path: "/members/{userId}/organizations",
        urlParamKeys: ["userId"],
    });
    invite = this.makeUpdateRequest({
        method: "POST",
        path: "/{orgId}/members/invite-user",
        urlParamKeys: ["orgId"],
    });
    inviteExistingUser = this.makeUpdateRequest({
        method: "POST",
        path: "/{orgId}/members/invite-existing-user",
        urlParamKeys: ["orgId"],
    });
    listIdentityProviders = this.makeRequest({
        method: "GET",
        path: "/{orgId}/identity-providers",
        urlParamKeys: ["orgId"],
    });
    linkIdp = this.makeRequest({
        method: "POST",
        path: "/{orgId}/identity-providers",
        urlParamKeys: ["orgId"],
        payloadKey: "alias",
    });
    unLinkIdp = this.makeRequest({
        method: "DELETE",
        path: "/{orgId}/identity-providers/{alias}",
        urlParamKeys: ["orgId", "alias"],
    });
    // Organization Invitations Management
    listInvitations = this.makeRequest({
        method: "GET",
        path: "/{orgId}/invitations",
        urlParamKeys: ["orgId"],
    });
    findInvitation = this.makeRequest({
        method: "GET",
        path: "/{orgId}/invitations/{invitationId}",
        urlParamKeys: ["orgId", "invitationId"],
    });
    resendInvitation = this.makeRequest({
        method: "POST",
        path: "/{orgId}/invitations/{invitationId}/resend",
        urlParamKeys: ["orgId", "invitationId"],
    });
    deleteInvitation = this.makeRequest({
        method: "DELETE",
        path: "/{orgId}/invitations/{invitationId}",
        urlParamKeys: ["orgId", "invitationId"],
    });
    groups = (orgId) => new Groups(this.#client, orgId);
}
//# sourceMappingURL=organizations.js.map